export default __webpack_public_path__ + "static/media/left-glow.449775a1.png";